import {
  CardChartRequest,
  CardChartResponse,
  GameCard,
} from "modules/cards/model/card";
import { useFetchWrapper } from "modules/common/hooks/useFetchWrapper";
import { API_ROUTES, CHART_RESPONSE_VERSION } from "utils/api-route.constants";
import { useQuery } from "@tanstack/react-query";
import { QUERIES } from "modules/common/query";
import { STATIC_DATA_CONFIG } from "modules/common/react-query-configs";
import {
  appendPricingParams,
  usePricingRequest,
  withPricingCacheKey,
} from "modules/common/hooks/usePricingRequest";

export const useCardChart = (card: GameCard, finish: string) => {
  const fetch = useFetchWrapper();
  const { pricing, cacheKey, isAuthReady } = usePricingRequest();
  const chartRequest: CardChartRequest = {
    cardId: card.id,
    ...pricing,
    finish,
  };
  const query = useQuery<CardChartResponse>({
    queryKey: withPricingCacheKey(
      [QUERIES.MAGIC_CARDS_CHART, chartRequest],
      cacheKey
    ),
    queryFn: () => chart(chartRequest),
    enabled: isAuthReady && !!chartRequest.cardId,
    ...STATIC_DATA_CONFIG, // 30min stale, no refetch - perfect for historical price data
    retry: false,
  });

  return {
    chartData: query,
  };

  function chart(r: CardChartRequest) {
    const params = new URLSearchParams({
      finish: r.finish,
      v: CHART_RESPONSE_VERSION,
    });
    appendPricingParams(params, pricing);
    return fetch
      .get(
        `${API_ROUTES.MAGIC_CARDS.CHART(r.cardId)}?${params.toString()}`,
        null
      )
      .then((res: CardChartResponse) => res);
  }
};
